import angular from 'angular';

import RenewSubscriptionNotificationComponent from './renew-subscription-notification.cmpt';

export default angular
    .module('application.component.notifications.component.renew-subscription-notification', [])
    .component(RenewSubscriptionNotificationComponent.selector, RenewSubscriptionNotificationComponent);



// WEBPACK FOOTER //
// ./src/application/component/notifications/component/renew-subscription-notification/index.js